import './modules/polyfills';
import './modules/sliders';
import './modules/social';
import * as Homepage from './modules/homepage';
import * as Work from './modules/work';
import * as LightboxVideos from './modules/lightboxVideos';
import * as Videos from './modules/videos';
import * as Utils from './modules/utils';

// Setup page load transitions
Utils.buildPage();

if (document.querySelector('.js-homepage')) {
    Homepage.init();
}

if (document.querySelector('.js-work')) {
    Work.init();
}

// Initialise Videos (a requirement of the youtube API!)
window.onYouTubeIframeAPIReady = function () {
    Videos.init();
    LightboxVideos.init();
}